@media (min-width: 1000px) {
  sl-card {
    max-width: 70vw;
  }
}
